import { getSupabase, ensureAnonSession } from './supabase.js';

// Direct client-side writes — RLS gates on seats membership + auth.uid match.
// No edge function needed.

export async function loadChat(gameId) {
  await ensureAnonSession();
  const db = getSupabase();
  const { data, error } = await db
    .from('chat_messages')
    .select('id, seat, display_name, text, created_at')
    .eq('game_id', gameId)
    .order('created_at', { ascending: true });
  if (error) throw error;
  return data ?? [];
}

export async function sendChat(gameId, { seat, display_name, text }) {
  await ensureAnonSession();
  const db = getSupabase();
  const { data: userResult } = await db.auth.getUser();
  const user = userResult?.user;
  if (!user) throw new Error('not_authenticated');
  const { error } = await db.from('chat_messages').insert({
    game_id: gameId,
    user_id: user.id,
    seat,
    display_name,
    text: text.trim().slice(0, 500),
  });
  if (error) throw error;
}

export function subscribeChat(gameId, onMessage) {
  const db = getSupabase();
  const channel = db
    .channel(`chat:${gameId}`)
    .on(
      'postgres_changes',
      { event: 'INSERT', schema: 'public', table: 'chat_messages', filter: `game_id=eq.${gameId}` },
      (payload) => onMessage(payload.new),
    )
    .subscribe();
  return () => {
    db.removeChannel(channel);
  };
}
